export const regexNameAndSurname = new RegExp(/^([a-zA-ZÀ-ÿ][-,a-zÀ-ÿ. ']*[ ]*)+$/);
export const regexEmail = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/);
export const regexPassword = new RegExp(/^.{6,}$/);
export const regexUpdateNameAndSurname = new RegExp(/^[a-zA-ZÀ-ÿ ]*$/);
